import PortalConfiguration from 'infrastructure/configuration/PortalConfiguration';
import FormFieldDescriptor from 'features/shared/forms/dynamicForm/models/FormFieldDescriptor';

export const loadConfiguration = (path: string): string => {
  let configuration = "";

  try {
    configuration = JSON.stringify(require(`configuration/${process.env.REACT_APP_CLIENT}/${path}`));
  } catch (error) {
    if ((error as any).code !== 'MODULE_NOT_FOUND') {
      throw error;
  }

    configuration = JSON.stringify(require(`configuration/default/${path}`));
  }

  return configuration;
}

export const loadModule = <T>(path: string): T => {
  let module:T;

  try {
    module = require(`configuration/${process.env.REACT_APP_CLIENT}/${path}`) as T;
  } catch (error) {
    if ((error as any).code !== 'MODULE_NOT_FOUND') {
      throw error;
  }

    module = require(`configuration/default/${path}`) as T;
  }

  return module;
}

export const loadDataFilterConfig = (dataFilterName: string): string => {
  return loadConfiguration(`datafilters/${dataFilterName}.json`);
}

export const loadDataSortConfig = (dataSortName: string): string => {
  return loadConfiguration(`dataSort/${dataSortName}.json`);
}

export const loadPortalConfig = (): PortalConfiguration => {
  return loadModule<PortalConfiguration>("shared/portalConfiguration.json");
}

export const existsModule = (path: string): boolean => {
  try {
    require(`configuration/${process.env.REACT_APP_CLIENT}/${path}`);
    return true;
  } catch (error) {
    if ((error as any).code !== "MODULE_NOT_FOUND") {
      throw error;
    }
  }

  return false;
};

export const loadDynamicFormConfig = (formName: string): FormFieldDescriptor[] => {
  const jsonConfig = loadConfiguration(`dynamicForms/${formName}.json`);

  if (jsonConfig) {
    return JSON.parse(jsonConfig) as FormFieldDescriptor[];
  }

  return [];
}